import { FileText, Lock, Zap } from 'lucide-vue-next';
import type { Feature } from '../types/feature';

export const features: Feature[] = [
  {
    icon: Zap,
    iconClass: 'h-8 w-8 text-amber-500',
    title: 'Omiń filtry ATS',
    desc: 'Algorytmy AI analizują i optymalizują Twoje CV, aby przeszło przez automatyczne systemy rekrutacyjne bez utraty kluczowych informacji.'
  },
  {
    icon: Lock,
    iconClass: 'h-8 w-8 text-emerald-500',
    title: 'Zero Halucynacji\nNo-Lie-Policy',
    desc: 'Nasza technologia nigdy nie dodaje fałszywych informacji. Wykorzystujemy tylko dane z Twojego CV, gwarantując autentyczność i prawdziwość.'
  },
  {
    icon: FileText,
    iconClass: 'h-8 w-8 text-blue-500',
    title: 'Import z LinkedIn',
    desc: 'Wgraj PDF profilu i zacznij działać bez przepisywania historii zatrudnienia.'
  }
];
